import { render, staticRenderFns } from "./V2CurrencyDropdown.vue?vue&type=template&id=23177800&scoped=true&"
import script from "./V2CurrencyDropdown.vue?vue&type=script&lang=js&"
export * from "./V2CurrencyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./V2CurrencyDropdown.vue?vue&type=style&index=0&id=23177800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23177800",
  null
  
)

export default component.exports